import {createSlice, type PayloadAction} from '@reduxjs/toolkit';

export interface InsightsContext {
    assetId: string;
    dusn: string;
    uamfApiUrl: string;
    uamToken: string;
    uamfApiKey: string;
    isRetail: boolean;
    isRangeModeEnabled: boolean;
}

interface InsightsState {
    context: InsightsContext | null;
}

const initialState: InsightsState = {
    context: null,
};

const insightsSlice = createSlice({
    name: 'insights',
    initialState,
    reducers: {
        setInsightsContext(state, action: PayloadAction<InsightsContext>) {
            state.context = action.payload;
        },
        setUamToken(state, action: PayloadAction<string>) {
            if (state.context) {
                state.context.uamToken = action.payload;
            }
        },
    },
});

export const {setInsightsContext, setUamToken} = insightsSlice.actions;

export default insightsSlice.reducer;
